<div class="col-12" *ngIf="gridload">
    <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid">
    <!-- <ngx-loading [show]="pageload"></ngx-loading> -->
    <div class="row">
        <div class="col-9">
            <h5 class=""><i class="fa fa-building"></i><b>Permits for Account {{dataCntrl.carrier.name}}</b></h5>
        </div>
        <div class="col-3 text-right">
            <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
        </div>
    </div>
    <hr>

    <div class="row">
        <div class="col-sm-12">
            <!-- <label><strong>Account Balance</strong></label>
              <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.carrier.account_balance"
               readonly /> -->
            <table class="table table-sm table-striped">
                <thead>
                    <tr>
                        <th>Account Number</th>
                        <th>Account Name</th>
                        <th>Trading Name</th>
                        <th>Registration Number</th>
                        <th>Lead User</th>
                        <th>Carrier Type Description</th>
                        <th>Account Balance</th>
                        <th>Account Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{acc.account_number}}</td>
                        <td>{{acc.account_name}}</td>
                        <td>{{acc.trading_name}}</td>
                        <td>{{acc.reg_number}}</td>
                        <td>{{acc.link_person}}</td>
                        <td>{{acc.carrier_type_description}}</td>
                        <td class="balance">{{dataCntrl.carrier.account_balance}}</td>
                        <td>{{acc.status}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>

    <br>
    <fieldset class="scheduler-border" style="align-content: float-right;">
        <legend class="scheduler-border tsk-display">Filters</legend>
        <!-- <legend class="scheduler-border tsk-display blackcontrol">Filters</legend> -->
        <div class="row" style="margin:15px auto!important;padding-left:100px;">
            <div class=" col-3 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
                <table class="" style="width:100%!important;margin:0px;padding:0px;" border="0">
                    <tr class="rmp-all">
                        <td class="col-md-2">
                            <input type="text" style="width:210px!important;height:35px;margin-right: 15px;" class="form-control form-control-lg" [(ngModel)]="permitNumber" placeholder="Filter by permit number..." title="Enter the Permit Number to filter by..." (keypress)="checkKey($event)">
                        </td>

                        <!-- <div class="col-4 resizer" style="width:350px; padding:0px" title="Select one or more statuses to filer by..."> -->
                        <!--td class="col-3 resizer">
              <div class="col-9 resizer" style="width:350px; padding:0px;" title="Select one or more statuses to filer by...">  
              <ng-multiselect-dropdown [placeholder]="'Filter by one or more statuses...'"
                                       [data]="statuses"
                                       [(ngModel)]="selectedItems"
                                       [settings]="dropdownSettings"
                                       (onSelect)="onItemSelect($event)"
                                       (onDeSelect)="onDeSelect($event)"
                                       (onSelectAll)="onSelectAll($event)">
              </ng-multiselect-dropdown>
            </div>
            </td-->
                        <td>
                            <span title="Apply filters..." (click)="onSearch()" class="btn btn-primary btn-sm" style="margin-right: -4px !important;"><i class="fa fa-filter" aria-hidden="true"></i></span>
                        </td>
                        <td>
                            <span (click)="onReset()" title="Reset filters..." class="btn btn-success btn-sm"><i class="fa fa-undo" aria-hidden="true"></i></span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </fieldset>
    <div class="row">
        <div class="col-md-12">
            <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
            <table class="table table-sm table-striped" *ngIf="appId == 0">
                <thead>
                    <tr>
                        <!--<th rowspan="2" style="min-width:100px !important;"></th>-->
                        <th rowspan="2" title="permit type description">PermitNum / Issue<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(1)"></i></th>
                        <th rowspan="2" title="permit type description">Permit Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>
                        <!--<<th rowspan="2"></th>-->
                        <!--<th rowspan="2">Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>-->

                        <th rowspan="2">Start<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                        <th rowspan="2">End<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(4)"></i></th>

                        <!-- <th colspan="2">Vehicle</th> -->
                        <th>Registration Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th>
                        <th rowspan="2">Route<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(6)"></i></th>
                        <!-- <th rowspan="2">Application Date<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th> -->
                        <th rowspan="2">Status<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(5)"></i></th>
                        <th rowspan="2" valign="bottom">
                            <!--Dropdown Menu     -->
                            <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title="" style="width:180px; float: right;">
                                <span title="Add a New Permit Application" class=" btn-add btn btn-primary pull-right" style="width: auto;">Apply for Permit</span>
                            </a>
                        </th>
                    </tr>
                    <!-- <tr>
                    <th>Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <th>Registration Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th>
                  </tr> -->

                </thead>
                <tbody>
                    <tr *ngFor="let item of dataCntrl.permits | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                        <ng-container *ngIf="item!=null">
                            <!--<td title="{{item.listRes.carrier.name}}">{{item.listRes.carrier.carrier_code}}</td>-->
                            <td>{{item.permit_num}} / {{item.permit_issue}}</td>
                            <!--<td>{{item.listRes.permit.face_value_num}}</td>-->
                            <td title="{{item.application.permit_type.description}}">{{item.application.permit_type.description}}</td>
                            <td><span *ngIf="item.date_valid_from!=null">
                      {{item.date_valid_from | date:'dd/MM/yyyy'}}</span></td>
                            <td>
                                <span *ngIf="item.date_valid_to!=null">{{item.date_valid_to | date:'dd/MM/yyyy'}}</span></td>

                            <!-- <td title = "{{item.listRes.vehicle_type}}">{{item.listRes.vehicle_type_code}}</td> -->
                            <td>{{item.vehicle_reg_num}}</td>
                            <td title="{{item.application.route_summary}}">{{item.application.route_summary}}</td>
                            <!-- <td>
                      <span *ngIf="item.listRes.submission_date!=null">
                        {{item.listRes.submission_date | date:'dd/MM/yyyy'}}
                      </span>
                    </td> -->
                            <td title="{{item.application.status}}">
                                <!--{{item.status_id}}->-->{{item.application.status}}</td>
                            <td>
                                <select class="form-control" (change)="navigatePermit(item,change)" id="selectControl" #change>
                        <option value="">Select</option>

                        <option class="app-option" [value]="'view'">View Permit</option>
                       <!-- <option class="app-option" [value]="'cancelApp'" *ngIf="item.application.status_id >= 21 && item.application.status_id <= 74">Cancel Permit</option>-->
                       <option class="app-option" [value]="'cancelApp'" *ngIf="item.application.status_id != 51 && item.application.status_id != 41 && item.application.status_id != 92">Cancel Permit</option>
                        <option class="app-option" [value]="'renew'" *ngIf="item.application.status_id >= 75 && item.application.status_id <= 80">Renew Permit</option>
                        <option class="app-option" [value]="'vehicle'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.is_valid">Vehicle Replacement</option>
                        <option class="app-option" [value]="'permitCorrection'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.application.permit_type.can_correct_error && item.is_valid">Error Correction</option>
                        <option class="app-option" [value]="'route'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && isCanBeAmended(item.application)">Route Amendment</option>
                        <option class="app-option" [value]="'duplicate'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.application.permit_type.can_get_duplicate">Duplicate Permit</option>
                        <option class="app-option" [value]="'edit'" *ngIf="(item.application.status_id >= 1 && item.application.status_id <= 2 )">Edit Application</option>
                        <option class="app-option" [value]="'delete'" *ngIf="(item.application.status_id >= 1 && item.application.status_id <= 11 )">Delete Application</option>



                        
                        <!-- <option class="app-option" [value]="'compliance'" *ngIf="item.listRes.status_id >=75  && item.listRes.status_id <= 80 ">Annual Compliance</option> -->
                        <!-- <option class="app-option" [value]="'compliance'" *ngIf="item.listRes.status_id >= 81 && item.listRes.status_id <= 85 || item.listRes.permit_type.annual_compliance_reqd" [disabled]="isComplianceReturned(item)">Annual Compliance</option> -->

                        <!-- <option class="app-option" value="compliance" *ngIf="item.listRes.status_id!=permitStatus4 && item.listRes.status_id!=permitStatus2 && item.listRes.permit_type.permit_years==5">Annual Compliance</option> -->
                        <!-- <option class="app-option" value="" *ngIf="item.listRes.status_id == permitStatus8 && item.listRes.permit_type.freight_passenger_ind==2">Upload Passenger Lists </option> -->
                        <!-- <option class="app-option" value="myNum" *ngIf="item.listRes.status_id == permitStatus8 && item.listRes.permit_type.freight_passenger_ind==1">Upload Consignment Notes</option> -->
                        <!-- <option class="app-option" value="viewPermit" data-target="#exampleModalLong" *ngIf="item.listRes.permit.status_id == permitStatus8">View Printed Permit</option> -->
                        <!--<option class="app-option" disabled value="myNum">Change Owner</option>-->
                        <!--<option class="app-option" [disabled]="!isCanBeAmended(item)" value="timetable">Change Timetable</option>-->
                        <!-- <option class="app-option" value="confirm" *ngIf="item.listRes.status_id == permitStatus8">Confirm Permit Details</option> -->

                      </select>

                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>


            <!-- For Permit Cancel From Application -->
            <ng-container *ngIf="appId > 0">
                <table class="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th rowspan="2" style="min-width:100px !important;"></th>
                            <th rowspan="2" title="permit type description">Permit#<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(1)"></i></th>
                            <th rowspan="2"></th>
                            <th rowspan="2">Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>
                            <th rowspan="2">Start<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                            <th rowspan="2">End<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(4)"></i></th>
                            <th rowspan="2">Status<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(5)"></i></th>
                            <th colspan="2">Vehicle</th>
                            <th rowspan="2">Route<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(6)"></i></th>
                            <!-- <th rowspan="2">Application Date<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th> -->
                            <th rowspan="2" valign="bottom">
                                <!--Dropdown Menu     -->
                                <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title="" style="width:180px; float: right;">
                                    <span title="Add a New Permit Application" class="btn-add btn btn-primary active"></span>Add
                                </a>
                            </th>
                        </tr>
                        <tr>
                            <th>Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                            <th>Registration<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr *ngFor="let p of permitObj.permits  | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                            <ng-container *ngFor="let a of this.dataCntrl.applications">
                                <td>{{a.listRes.carrier.carrier_code}}</td>
                            </ng-container>
                            <td>{{p.permit_num}} / {{p.permit_issue}}
                            </td>
                            <td> <span *ngIf="p.face_value_num!=null">{{p.face_value_num}}</span></td>
                            <ng-container *ngFor="let a of this.dataCntrl.applications">
                                <td>{{a.listRes.permit_type.code}}</td>
                            </ng-container>
                            <td><span *ngIf="p.date_valid_from!=null">
                      {{p.date_valid_from | date:'dd/MM/yyyy'}}</span></td>
                            <td>
                                <span *ngIf="p.date_valid_to!=null">{{p.date_valid_to | date:'dd/MM/yyyy'}}</span></td>
                            <td><span *ngIf="p.status_id!=null">{{p.status_id}}-{{p.status_description}}</span></td>
                            <ng-container *ngFor="let item of this.dataCntrl.applications">
                                <td title="{{item.listRes.vehicle_type}}">{{item.listRes.vehicle_type_code}}</td>
                                <td>{{item.listRes.registration_number}}</td>
                            </ng-container>

                            <ng-container *ngFor="let a of this.dataCntrl.applications">
                                <td title="{{a.listRes.route_summary}}"><span *ngIf="a.route_code!=null">{{a.route_code}}</span></td>
                                <!-- <td>
                      <span *ngIf="a.listRes.submission_date!=null">
                        {{a.listRes.submission_date | date:'dd/MM/yyyy'}}
                      </span>
                    </td> -->
                            </ng-container>
                            <td>
                                <select class="form-control" (change)="cancelApplication(p.id)" id="selectControl" #change>
                            <option value="">Select</option>
                            <option class="app-option" value="cancelApp" >Cancel Application</option>
                        </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>




            <p class="use-mouse" *ngIf="dataCntrl.applications.length > 0">Click on the Underlined link to view account information</p>
            <div style="text-align:center" *ngIf="Count > 5">
                <table border="0" cellpadding="0" cellspacing="0" style="float: right;">
                    <tr>
                        <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                            Show :
                        </td>
                        <td style="white-space: nowrap">
                            <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                        <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                      </select>
                        </td>
                    </tr>
                </table>
                <pagination-controls class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>
            </div>
            <div>
                <tfoot>
                    <tr *ngIf="isEmpty">
                        <td colspan="9" class="rm-brd">
                            <span class="text-info text-small; color:black">No permits found.</span>
                        </td>
                    </tr>

                </tfoot>

            </div>
            <!-- <div style="text-align:center" *ngIf="dataCntrl.applications.length <= 0 && loadCompleted">
                <h5>No Permits Found</h5>
              </div>-->
        </div>
    </div>
    <div>
        <div class="card-data">
            <div class="col-md-12">
                <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary pull-right" style="margin-left:10px; ">Back</button>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Printed Permit</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-lg">

                <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" [original-size]="false" [autoresize]="true"></pdf-viewer>

                <ngx-loading [show]="isLoadingImg"></ngx-loading>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
                <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
            </div>
        </div>
    </div>
</div>
